import React from 'react'; 
import './Zen-Frescos.css'; 

import '../../Button.css'; 

function ZenFrescosMandarin() { 

  window.scrollTo(0, 0)

    return (
      <>
          
          <div className="artist-section"> 

          <form method="get" action="#/zen-frescos"> 
            <button id="the-button" type='btn'>English</button> 
          </form> 

            {/* Artist Name */} 

            <h1 className="artist">法海禅寺壁画的收藏与鉴赏，韩志军</h1> 
            <hr /> 

            {/* Artist Summary */}

            <p id="art-paragraph">
            Avatamsaka Sutra says: "There are five color flowers in Buddha's world. Through flowers, 
            one can see a world in a single piece of flower, one can see a Buddha in a single piece 
            of leaf." The venerable layperson Mr. Puchu Zhao once said: "There are Buddha’s worlds 
            in Buddhist paintings. Buddhist paintings manifest Buddha’s worlds." Using artwork as 
            expedient way to spread Buddha’s doctrine has more than 2000 years of history in China. 
              </p> 

              <p id="art-paragraph-other">
              As it is said in Buddhism: "Experience the nature of the mind through seeing phenomena. 
              The nature of the mind cannot be perceived without the presence of the phenomena. 
              ”Buddhism and the art are interrelated through mutual complement and enhancement. 
              The extraordinary karmic bonds between the Buddhist Dharma and Chinese mural paintings 
              brought Chinese Buddhist mural paintings to its culmination of charisma which reflect 
              the majesty of the Buddhist world and perfection of the Avatamsaka Cosmos. Chinese 
              Buddhist mural paintings glorified the essence of Buddhism, and the Buddhist 
              transcendental wisdom elevated the glamour of Chinese Buddhist mural paintings to 
              its highly respected height in the world.  Chinese Buddhist mural painting is the 
              Prajna of art which annotates the emptiness wisdom of the reality in Buddhism.
              </p> 

              {/* -------------- */}
              <img src="./ZF1.jpeg" id="painting-zf"></img>
              <h5 id="caption">The Avalokitesvara with Water and Moon</h5> 
              {/* -------------- */} 

              <h3 id="little-title">
              A、Fahai Zen Monastery Frescoes
              </h3>

              <p id="art-paragraph-other">
              Fahai Zen Monastery Frescoes were painted by 15 royal painters including painting 
              officer Fuqing Wan, Shu Wang, painter Ping Zhang, Yi Wang, Xing Gu, Yuan Li, Fu Pan, 
              and Fulin Xu, who were appointed and supervised by royal eunuch Li, Tong, during 
              period of Zhengtong reign year 4th to year 8th ( A.D. 1439-A. D.1443) of Ming Dynasty, 
              in the main shrine hall of the royal zen monastery. They encompass:
              </p> 

              {/* Bullet Points */} 

              <ul id="list">
                <li id="bullet">
                • The Avalokitesvara with Water and Moon
                </li>
                <li id="bullet">
                • Portrait of Manjusra
                </li>
                <li id="bullet">
                • Portrait of Samantabhadra
                </li>
                <li id="bullet">
                • Indra and Brahma Prostrating Buddha and Protecting Dharma
                </li>
                <li id="bullet">
                • Buddhist Families Heading to Dharma Teaching
                </li>
                <li id="bullet">
                • Auspicious Cloud, and more
                </li>
              </ul> 

              {/* -- */} 

              <p id="art-paragraph-other">
              Among them, the “The Avalokitesvara with Water and Moon” and the “indra and Brahma 
              Prostrating Buddha and Protecting Dharma” are the most representative masterpieces. 
              Fahai Zen Monastery Frescoes have notable Ming Dynasty hints with heritages from 
              the Tang Dynasty, the 5 Dynasties, and the Song Dynasty. They exhibit exquisite 
              subtlety, clear patterns, dazzling tone, and deep dharma philosophy through narrative 
              plot, arrangement of the figures, image design of subjects and composition of elements. 
              They integrate the metaphoric meaning and the Buddhist transcendental wisdom with the 
              statues of the Buddha and Bodhisattva. These paintings convey the emptiness nature of 
              all phenomenons. 
              </p> 

              <p id="art-paragraph-other">
              The frescoes cause people to experience the nature of mind directly. The frescoes merge 
              symbols, landscapes, flowers, woods and stone with smooth lines and bright colors. 
              Along with the rituals and disciplines of Buddhism, they are painted in the traditional 
              Chinese meticulous painting method, which is characterized by delicate brushstrokes, 
              close attention to details, brightly dotted colors and strict requirements in material 
              selections. They fully reflect the distinguished elegance, royal grandeur, and 
              meticulousness of the Imperial family. The Fahai Zen Monastery Frescoes are the aesthetic 
              masterpieces among the noblest, the most matured, the most sophisticated Chinese Monastery 
              Murals. The artistry of the murals reached its apogee by congregating the quintessence of 
              Chinese monastery mural paintings through all periods. They generated a spectacular example 
              of religious art in human art history.
              </p> 

              <p id="art-paragraph-other">
              In 1993, antique appraisers, artists and religious leaders from Beijing evaluated Fahai 
              Zen Monastery Frescoes in its historical value, religion, art and painting skills. Through 
              comparison with the murals from Yuan Dynasty, Ming Dynasty, Qing Dynasty , experts 
              collectively agreed that Fahai Zen Monastery Frescoes have their own merits, which could 
              match the beauty of renaissance murals in Europe. They are among the most precious masterpieces 
              in world mural art. Fahai Zen Monastery Frescoes are first-grade national treasures in China. 
              </p> 

              <p id="art-paragraph-other">
              When the late legendary Chinese mural painting expert Mr. Dingli Wang (1925-2009) led the 
              restoration and conservation of Yongle Frescoes, he found many mistakes and immaturities in 
              the paintings. However, after a comprehensive study, he could not find a single stroke of 
              mistake in Fahai Zen Monastery Frescoes. The late remarkable Chinese meticulous painter 
              Mr. Jiezi Pan said: “Among the all ancient mural paintings I ever saw, Fahai Zen Monastery 
              Frescoes are the most detailed mural paintings that delimit details precisely.” He also 
              composed a poem for Fahai Monastery Frescoes:
              </p> 

              <p id="art-paragraph-poem">
              “Dunhuang Frescoes have both successful and unsuccessful brushstrokes among the marvelousness; 
              the detailed illustration of Yongle Palace Frescos are the benchmarks for meticulous paintings. 
              However, Fahai Monastery’s mural paintings are the most meticulous one of all the periods. 
              No other painting can compare itself with the exquisite details and metaphoric meanings of 
              Fahai Zen Monastery Frescoes. What else painting can compete itself with the mystically elegant 
              significance of the Fahai Monastery Frescoes?” 
              </p> 

              {/* -------------- */}
              <img src="./ZF2.jpeg" id="painting-zf"></img>
              <h5 id="caption">Portrait of Manjusri</h5> 
              {/* -------------- */} 

              <p id="art-paragraph-other">
              Chinese notable contemporary artists including Mr. Lingyun Qin, Mr. Weinuo Jin 
              and Mr. Yongnian Xue also gave Fahai Monastery Frescoes high evaluations. Fahai 
              Monastery Frescoes are treated as the highest achievement in Buddhist mural art 
              after the exploration of Kizil Caves Grottoes and Kucha Grottoes of A.D. 3 to 
              A.D. 4, for its exquisite, its solemnity, its magnificence, and its aesthetic 
              values.
              </p> 

              <p id="art-paragraph"> 
              The “The Avalokiteshvara with Water and Moon”  of Fahai Zen Monastery Frescoes 
              is acclaimed as the most significant painting of Avalokiteshvara in both Buddhist 
              and Art Communities.  Through the use of typical Buddhist elements, like crown, 
              keyura, seamless heavenly garment, silk gauze, and luminous light, the frescoes 
              symmetrically parallelled Sudhanakumara, Skanda Bodhisattva, Golden Haired Hou-the 
              steed of Avalokitesvara, parrot. 
              </p> 

              <p id="art-paragraph-other">
              On the immense watery cloud background, the frescoes are spotted auspicious clouds, 
              bamboo garden, red peony, red coral, magnolia tree, artocarpus tree, eupatorium flower, 
              and treasure vase, symbolizing longevity mountain, symbolizing prosperity ocean, and 
              clear spring water; all of those Buddhist elements bring out the evocative brightness 
              and solemnity of Buddhist pure-land and the Buddhist meaning of“ the dependent existing 
              of the heavens is not a truly existence; the true nature of the watery moon is emptiness”. 
              </p> 

              <p id="art-paragraph-other">
              By adopting the painting skills in Song Dynasty, Fahai Zen Monastery Frescoes attribute 
              human characteristics and emotional charm to Avalokiteshvara. As a result of this effort, 
              Avalokiteshvara has a heart-warming deportment, tranquil and compassionately amicable 
              expression. The frescoes fully reflect the Buddhist teachings of transcendence wisdom and 
              life liberation. Just looking at “The Avalokiteshvara with Water and Moon” silently, the 
              painting will bring us into the Buddha’s world of emptiness and infinite compassion. That 
              is a world of nonduality. It is incredible to find the similarities between the “The 
              Avalokiteshvara with Water and Moon” of Fahai Zen Monastery Frescoes and the “Sistine Madonna  
              of Sistine Chapel,  Italian Painter Raffaello Sanzio da Urbino of the High Renaissance. 
              The painting of “The Avalokiteshvara with Water and Moon” is crowned the eastern “Sistine Madonna”. 
              </p> 

              <p id="art-paragraph-other">
              There are common figures like Buddha, Bodhisattva, yama, arahat, deva, Nāga, Yakṣ a, 
              Gandharva, Asura, Garuḍa, Kiṁnara, Mahoraga, Buddhist venerables in Chinese traditional 
              Buddhist paintings.”Indra and Brahma Prostrating Buddha and Protecting Dharma” depicts 
              heavenly kings and Nagas leading celestial beings, like Yakṣa, Gandharva,Asura, Garuḍa, 
              Kiṁnara,Mahoraga to Buddhist life releasing ceremony. In addition to the 26 celestial 
              pure ones, there are totally 36 humanized celestial figures and 7 divine animal figures 
              were painted on the eastern and the western wall of the main shrine hall. Some of them 
              are ghost spirit, devi, mantra master, green lion, white elephant, leopard, boar, fox, 
              golden toad, and purple golden dragon. 
              </p> 

              <p id="art-paragraph-other">
              The “Indra and Brahma Prostrating Buddha and Protecting Dharma” was composed by murals 
              of the eastern wall and western wall. Standing face to face, Indra and Brahma lead 
              celestial beings, ghost beings, female devas, mantra masters heading to puja. They are 
              either in small groups, or greeting each other, or performing their supernatural power. 
              All those components together result in a vigorous, magnificent, stunning and breathtaking 
              scenario of mightiness. All figures are related but each figure has a unique expression 
              to convey different identity, characteristic and quality. 
              </p> 

              <p id="art-paragraph-other">
              Through expression, appearance, posture, gesture, holding item, Dharma instrument, 
              attire, accessory, color, auspicious cloud, celestial animal, grass and flower of 
              each figure, the illustrations on Fahai Zhen Monastery Frescoes reflect the Buddhist 
              stories and teachings with wish fulfilled blessing. Differentiated not only through 
              holding item and body movement, each figure is characterized by its unique reaction 
              for the same activity. 
              </p> 

              {/* -------------- */}
              <img src="./ZF3.jpeg" id="painting-zf"></img>
              <h5 id="caption">Portrait of Samantabhadra</h5> 
              {/* -------------- */} 

              <p id="art-paragraph-other">
              For instance, Caturmahārājakayika ( heavenly king) and vajrapani both are Buddhist 
              protectors with majestic appearance and great dignity. In the “Indra and Brahma 
              Prostrating Buddha and Protecting Dharma”, the heavenly king is portrayed especially 
              in his tenderness and sedateness. On the other hand, Vajrapani, the “wielder of the 
              thunderbolt” in Buddhist liturgy is with wrathful looking. By humanizing heavenly 
              beings with emotions and feministic personalities, the heartwarming murals are more 
              closed to real-life situations. 
              </p> 

              <p id="art-paragraph-other">
              The ancient Chinese dialectical concepts in philosophy are appropriately interpreted 
              through dramatically composed plot, symbolized appearance, majesty and compassion of 
              the figures. The Fahai Zen Monastery Frescoes created great contributions to Chinese 
              mural history. 
              </p> 

              <p id="art-paragraph-other">
              In term of painting process and techniques, Fahai Zen Monastery Frescoes have reached 
              its culminating point with everlasting artistic power for it. They manifest the splendid 
              and sumptuous essence of Chinese court painting, a thousand years of Dunhuang Frescoes, 
              and Shanxi province’s Yongle Frescoes of the Yuan Dynasty in both appearance and composition. 
              They have Gu, Kaizi’s brush lines of “Spring Silkworms Spitting Silk”, Cha, Zhongda’s 
              “Wet-clothing Drawing”, and Wu Daozi’ s “Wu's Belt Floating in Wind". Mural paintings were 
              colored with powdered gold. People can even see realistic strands of hair through its skilled 
              brushstroke techniques like Lanye Miao, Tiexian Miao, Zhelu Miao, Zhanbi Miao, Gaoguyousi Miao, 
              Dingtoushuwei Miao. From the overall perspective, it has magnificent rhythm, vivid contrast 
              and bold floating lines. It demonstrates unique technique through multiple layers, texture and 
              authentic genius. Additionally, it applied stringent techniques in material selection along 
              with complicated procedures. It is impeccable and incomparable.
              </p> 

              <p id="art-paragraph-other">
              The various values of the Fahai Zen Monastery Frescoes in religion, Buddhist teaching, and 
              visual art exceed the original painting purpose. Fahai Zen Monastery Frescoes are the rare 
              gems for Buddhist cultural studies. There are more values waiting there to be explored, to 
              be inherited, to be brought out from monastery to people, from people to the world. 
              </p> 

              <h3 id="little-title">
              B、The “Beijing Fahai Zen Monastery Mural Paintings”
              </h3>

              <p id="art-paragraph-other">
              Due to the tight protection by Chinese government, Fahai Zen Monastery Frescoes are not popular 
              as they should be. Since 1993, various government agents made efforts to evaluate and 
              photographically document Fahai Zen Monastery Frescoes. In order to avoid the further deterioration 
              from light and carbon dioxide, most lighting equipments are prohibited in the main shrine hall. 
              The scholars who get permits to enter the site are only allowed to us small flashlight.
              </p> 

              <p id="art-paragraph-other">
              In order to restore the elegant demeanors of Fahai Zen Monastery Frescoes, Chinese meticulous 
              painting guru Mr. Sheng Huayong drew Fahai Monastery Frescoes over a period of more than 20 years. 
              Inheriting the expertise of his legendary teacher Mr. Wang Dingli’s in Chinese Fresco’s restoration, 
              mineral material selection and copy painting of Chinese ancient visual art, he drew mural paintings 
              in original colors on paper. He overcame many difficulties to abide his strict, rigorous attitude 
              and professional standards. The Fahai Monastery Mural Paintings lift the 600 years old mystical 
              veil of marvelousness. They miraculously reincarnate the frescoes of the ancient court monastery.
              </p> 

              <img src="./ZF4.jpeg" id="painting-zf"></img>
              <h5 id="caption">Indra and Brahma Prostrating Buddha</h5> 

              <img src="./ZF5.jpeg" id="painting-zf"></img> 
              <h5 id="caption">Protecting Dharma</h5> 

              <p id="art-paragraph-other">
              Copying and imitation are popular in Chinese painting history. Copy painting is not only a way 
              to practice painting skills, but is also a way to inherit the traditions in ancient art. Depending 
              on copy painting, many original ancient paintings were survived from vanishing in Chinese art 
              history. Some of them are: 
              </p> 

              {/* Bullet Points */} 

              <ul id="list">
                <li id="bullet">
                • Heavenly King 
                </li>
                <li id="bullet">
                • Bestowing Boy
                </li>
                <li id="bullet">
                • Han Xizai Evening Banquet
                </li>
                <li id="bullet">
                • Celestial Beings Worship The Purest Ones
                </li>
                <li id="bullet">
                • Along the River During the Qingming Festival
                </li>
                <li id="bullet">
                • Thousand Buddha 
                </li>
                <li id="bullet">
                • Dwelling in the Fuchun Mountain 
                </li>
              </ul> 

              {/* -- */} 

              <p id="art-paragraph-other">
              The connotations of copy painting changed in Yuan Dynasty. Many famous painters practiced copy 
              painting to gain techniques and to probe the essential qualities of a past master's style. 
              </p> 

              <p id="art-paragraph-bottom">
              Since the period of Shuhong Chang, Wenjie Duan, there are three popular methods in mural copy painting.
              </p> 

              <p id="art-paragraph-bottom-mobile">
              Since the period of Shuhong Chang, Wenjie Duan, there are three popular methods in mural copy painting.
              </p> 

              {/* Number Points */} 

              <ul id="list">
                <li id="bullet">
                1. Exactly replicate the existing state of condition , is called “Objectively Replicating Method”
                </li>
                <li id="bullet">
                2. Complement to the original state, based on the existing state of condition, is called  “Complement based on existing state of Condition”
                </li>
                <li id="bullet">
                3. Copy exactly to the original, new condition, is called “Copy As The Original New”. 
                </li> 
              </ul> 

              {/* -- */} 

              <p id="art-paragraph-other">
              The“ Beijing Fahai Zen Monastery Mural Paintings”were copy painted by using the third method 
              “Copy as Original New”, are the most representative copy paintings of Fahai Zen Monastery 
              Frescoes. The differences from the original frescoes are:
              </p> 

              {/* Number Points */} 

              <ul id="list">
                <li id="bullet">
                1. The original murals were painted on wall, the replicas were painted on rice paper. 
                </li>
                <li id="bullet">
                2. Individually, the sizes of replicas are one fourth and half of the original murals.
                </li>
                <li id="bullet">
                3. Beijing Fahai Monastery Mural Paintings lift the 600 years mystical veil of marvelousness.  
                </li> 
              </ul> 

              {/* -- */} 

              <p id="art-paragraph-other">
              The painter’s solid background in mural painting, his knowledge in mineral material selection, education 
              in art history, and his understanding and sensibility to colors should be credited for the miraculous 
              reincarnation of the frescoes in Fahai Zen Monastery.
              </p> 

              <p id="art-paragraph-other">
              The government intensified the protection of the Fahai Zen Monastery Frescoes. It is impossible 
              to do copy paintings or to take pictures on the site. Due to limited technology in photography 
              many years ago, the negative taken during restoration and conservation, cannot collect all the 
              information. The smoggy weather during the past 20 years in Beijing continually eroded the Fahai 
              Zen Monastery Frescoes. Therefore, the currently limited versions of mural paintings become tremendously 
              precious. Unlike the frescoes on the walls of monasteries and caves, the copy paintings of Fahai Zen 
              Monastery Frescoes can be detached from walls and therefore are portable. The copy paintings are 
              rare classic paintings, could be kept as personal collection, in library, in museum, could be used 
              in Buddhist teaching and practice, art popularization, international culture exchange, art teaching, 
              pattern designing. Fahai Zen Monastery Frescoes copy paintings are the treasures for cultural protection 
              and heritage, exploration and the promotion of art. 
              </p> 

              <p id="art-paragraph-other">
              Chinese ancestors said “ as a gentleman, he should be able to master and hold on the original one 
              ". Similarly, Fahai Zen Monastery Frescoes copy paintings embody the original purpose of the frescoes, 
              which is the essential teachings of Buddhism. Based on the devotion to his faith, the painter made 
              the copy paintings to be time-lasting masterpieces of this kind. It reveals his confidence in Chinese 
              culture and tradition during his pursuing of life purpose. 
              </p> 

              <p id="art-paragraph-other">
              After experiencing 600 years, almost 10 cycles of sixty years of repeatedly damages in wars, of Dynasty 
              changes and of human civilization, the Fahai Zen Monastery Frescoes encompass an unprecedented era. 
              The appearance of Fahai Zen Monastery Frescoes on paper is an important step, a symbol, a signal of 
              the upcoming "great renaissance of the Chinese nation". Starting from China, the ancient eastern Buddhist 
              wisdom and concept of tranquility will be spread out all over the world. 
              </p> 

              <h3 id="little-title">
              C、Limited Engraved Reproduction of《Beijing Fahai Zen Monastery Mural Paintings》
              </h3> 

              <p id="art-paragraph-other">
              The artwork imitation is a rigorous process of recreation. Technology could play an essential role in the 
              reproduction of ancient artwork and could make tremendous differences. However, the traditional printing 
              technology, like woodblock printing or collotype technology printing can not meet the aesthetic standards 
              to reflect the characteristics of the original ones. 
              </p> 

              <p id="art-paragraph-other">
              In addition to the on-site research, the image data analysis, new technology, and innovations in material 
              selections, the reproduction of “Beijing Fahai Zen Monastery Mural Paintings” is based upon Mr. Sheng 
              Huayong’s copy of the Fahai Zen Monastery Frescoes. It is a perfect combination of Buddhist teaching, 
              visual art, technology, and the applications of materials. It denotes Buddhist Prajna in artistry. It is 
              a new attempt in aesthetic, in visual art, and in the area of art reproduction. 
              </p> 

              <p id="art-paragraph-other">
              On the artistic level, they are prototypes of Buddhist transcendental wisdom through its proficient Buddhist 
              visual art languages of the Ming Dynasty. They depict the solemn magnificence of Buddha and Bodhisattva. 
              This way, they can fulfill both Buddhist and artistic requirements. They artistically emphasize the Buddhist 
              celestial meanings by strictly following Buddhist disciplines and wisdom. They vividly interpret Zen’s process 
              of directly pointing to the mind in an expedient way through paper mural painting. To reconcile with the original 
              drawings in both texture and colors, especially the traits of materials and the subtle micro-features of colors, 
              several efforts are implemented, like using acid-free rice paper, coating spread, mineral colors and much more. 
              It They mold properly in the value of spirituality, significance, grandeur, magnificence, solemnity, majesty, 
              expression, and the value of visualization. They bring forth the resplendence of mural paintings in Ming royal 
              palaces. Utilizing the skills of ancient mural painting art, they create new standards and phenomenon.
              </p> 

              <p id="art-paragraph-other">
              Technologically, they strictly followed the image engraving technologies popularized among craftsmen during 
              the procedures of image information acquisition, component printing, and plate making. They applied customized 
              rice paper, coating spread, and mineral colors. Custom designed software and specially made upgraded facilities 
              are utilized to process the tremendous amount of digital databases. The reproduction is performed under anti-dust 
              and anti-static working environment, along with complicated art skills and anti-forgery technologies. The 
              qualities of the final printouts are far higher than the traditionally made.
              </p> 

              <p id="art-paragraph-other">
              The “ Beijing Fahai Zen Monastery Mural Paintings” encompasses about 5 five paintings which are as followings 
              follow: “The Avalokitesvara with Water and Moon”, ”Portrait of Manjusri”, ”Portrait of Samantabhadra”, ”Indra 
              and Brahma Prostrating Buddha and Protecting Dharma”(The East of Northern Wall), and ”Indra and Brahma Prostrating 
              Buddha and Protecting Dharma” ( The West of Northern Wall). They have following features: 
              </p> 

              {/* Number Points */} 

              <ul id="list">
                <li id="bullet">
                1. The resolution accuracy in image information acquisition is greater than 20G per square meter. The number is far higher than the industrial standard of giclee printing.
                </li>
                <li id="bullet">
                2. In order to make the printing never faded and to reconcile with the original drawings in both texture and colors, especially the traits of materials and the subtle micro features of colors, several efforts are implemented, like using no acid acid-free rice paper, coating spread, mineral colors and much more .
                </li>
                <li id="bullet">
                3. From customized rice paper making to silk brocade making, anti-forgery techniques are used in each step of reproduction. Each printing has its unique anti-fraud universal barcode distinguishing its limited edition printout and its worldwide copyright registration numbers. An IC chip embedding universally unique identifier, which is unchangeable, uncopiable, duplicable, irreplaceable with numerous digital data , is inserted in each printing with its unique electronic DNA identity barcode.
                  By using cellphone’s NFC function, authorized collectors on the Fahai Zen Monastery Frescoes’ website can get into the customer database management system to attain the DNA anti-forgery barcode for each printing.
                </li> 
                <li id="bullet">
                4. In order to make the printing never faded, no acid rice paper and mineral colors are applied in production.
                </li> 
                <li id="bullet">
                5. Measurements: 
                </li>
              </ul> 

              {/* -- */} 

              <hr /> 

              <h3 id="little-title">
              (Display Version) 
              </h3> 

              {/* 1 */}
              <p id="art-paragraph-bottom">
              Measurements in Chinese Celestial Approach 
              </p>

              <p id="art-paragraph-bottom-mobile">
              Measurements in Chinese Celestial Approach 
              </p>
              {/* -- */}

              {/* 2 */}
              <p id="art-paragraph-bottom">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra ,
              Height 106.5 cm, Auspicious/ Fertility Power Width 108.5 cm, Good Luck in Exam/ Prosperity        
              </p>

              <p id="art-paragraph-bottom-mobile">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra ,
              Height 106.5 cm, Auspicious/ Fertility Power Width 108.5 cm, Good Luck in Exam/ Prosperity   
              </p>
              {/* -- */}

              {/* 3 */}
              <p id="art-paragraph-bottom">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West)
              </p>

              <p id="art-paragraph-bottom-mobile">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West)
              </p>
              {/* -- */}

              {/* 4 */}
              <p id="art-paragraph-bottom">
              Height 106.5 cm, Auspicious/ Fertility Power Width 273.6 cm, Embrace Happiness/ Prosperity
              </p>

              <p id="art-paragraph-bottom-mobile">
              Height 106.5 cm, Auspicious/ Fertility Power Width 273.6 cm, Embrace Happiness/ Prosperity 
              </p>
              {/* -- */}

              {/* 5 */}
              <p id="art-paragraph-bottom">
              Scroll Measurements after Mounting in Chinese Celestial Approach
              </p>

              <p id="art-paragraph-bottom-mobile">
              Scroll Measurements after Mounting in Chinese Celestial Approach
              </p>
              {/* -- */}

              {/* 6 */}
              <p id="art-paragraph-bottom">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra》
              </p>

              <p id="art-paragraph-bottom-mobile">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra》
              </p>
              {/* -- */}

              {/* 7 */}
              <p id="art-paragraph-bottom">
              Scroll Height 217 cm, Treasure House, Money/ Good Luck in Exam Width 126 cm, Prosperity/Embrace Happiness
              </p>

              <p id="art-paragraph-bottom-mobile">
              Scroll Height 217 cm, Treasure House, Money/ Good Luck in Exam Width 126 cm, Prosperity/Embrace Happiness
              </p>
              {/* -- */}

              {/* 8 */}
              <p id="art-paragraph-bottom">
              Scroll Rod Width 136 cm, Fertility Power/Prosperity
              </p>

              <p id="art-paragraph-bottom-mobile">
              Scroll Rod Width 136 cm, Fertility Power/Prosperity
              </p>
              {/* -- */}

              {/* 9 */}
              <p id="art-paragraph-bottom">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West)
              </p>

              <p id="art-paragraph-bottom-mobile">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West)
              </p>
              {/* -- */}

              {/* 10 */}
              <p id="art-paragraph-bottom">
              Scroll Height 126 cm, Prosperity/ Embrace Happiness Width 300.5 cm, Power in Politics, Attaining/ Prosperity
              </p>

              <p id="art-paragraph-bottom-mobile">
              Scroll Height 126 cm, Prosperity/ Embrace Happiness Width 300.5 cm, Power in Politics, Attaining/ Prosperity
              </p>
              {/* -- */}

              <hr /> 

              <h3 id="little-title">
              (Family Version) 
              </h3> 

              {/* 1 */}
              <p id="art-paragraph-bottom">
              Measurements in Chinese Celestial Approach
              </p>

              <p id="art-paragraph-bottom-mobile">
              Measurements in Chinese Celestial Approach
              </p>
              {/* -- */}

              {/* 2 */}
              <p id="art-paragraph-bottom">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra》
              </p>

              <p id="art-paragraph-bottom-mobile">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra》
              </p>
              {/* -- */}

              {/* 3 */}
              <p id="art-paragraph-bottom">
              Height 60 cm, Fertility Power/ Profitable
              </p>

              <p id="art-paragraph-bottom-mobile">
              Height 60 cm, Fertility Power/ Profitable
              </p>
              {/* -- */}

              {/* 4 */}
              <p id="art-paragraph-bottom">
              Width 61 cm, Profitable/Power in Politics/Fertility Power 
              </p>

              <p id="art-paragraph-bottom-mobile">
              Width 61 cm, Profitable/Power in Politics/Fertility Power
              </p>
              {/* -- */}

              {/* 5 */}
              <p id="art-paragraph-bottom">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West) 
              </p>

              <p id="art-paragraph-bottom-mobile">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West)
              </p>
              {/* -- */}

              {/* 6 */}
              <p id="art-paragraph-bottom">
              Height 60cm, Fertility Power/ Profitable 
              </p>

              <p id="art-paragraph-bottom-mobile">
              Height 60cm, Fertility Power/ Profitable
              </p>
              {/* -- */}

              {/* 7 */}
              <p id="art-paragraph-bottom">
              Width 154.4 cm, Gaining Profit/Glorious Wealth/Gaining Treasure/Wealth and Merit
              </p>

              <p id="art-paragraph-bottom-mobile">
              Width 154.4 cm, Gaining Profit/Glorious Wealth/Gaining Treasure/Wealth and Merit
              </p>
              {/* -- */}

              {/* 8 */}
              <p id="art-paragraph-bottom">
              Scroll Measurements after Mounting in Chinese Celestial Approach
              </p>

              <p id="art-paragraph-bottom-mobile">
              Scroll Measurements after Mounting in Chinese Celestial Approach
              </p>
              {/* -- */}

              {/* 9 */}
              <p id="art-paragraph-bottom">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra》
              </p>

              <p id="art-paragraph-bottom-mobile">
              《The Avalokitesvara with Water and Moon》、《Portrait of Manjusri》、《Portrait of Samantabhadra》
              </p>
              {/* -- */}

              {/* 10 */}
              <p id="art-paragraph-bottom">
              Height 80.6 cm, Wealth Arrival/Prosperity/Good Luck in Exam and Be Accepted
              </p>

              <p id="art-paragraph-bottom-mobile">
              Height 80.6 cm, Wealth Arrival/Prosperity/Good Luck in Exam and Be Accepted
              </p>
              {/* -- */}

              {/* 11 */}
              <p id="art-paragraph-bottom">
              Width 81.6 cm, Wealth Arrival/Prosperity/Good Luck in Exam and Be Accepted
              </p>

              <p id="art-paragraph-bottom-mobile">
              Width 81.6 cm, Wealth Arrival/Prosperity/Good Luck in Exam and Be Accepted
              </p>
              {/* -- */}

              {/* 12 */}
              <p id="art-paragraph-bottom">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West)
              </p>

              <p id="art-paragraph-bottom-mobile">
              《Indra and Brahma Prostrating Buddha and Protecting Dharma》 ( Protection on East, Protection on West)
              </p>
              {/* -- */}

              {/* 13 */}
              <p id="art-paragraph-bottom">
              Height 80.6 cm, Wealth Arrival/Prosperity/Good Luck in Exam and Be Accepted Width 192 cm, Auspicious/Good 
              Luck in Exam and Be Accepted/Prosperity/Gaining Treasure
              </p>

              <p id="art-paragraph-bottom-mobile">
              Height 80.6 cm, Wealth Arrival/Prosperity/Good Luck in Exam and Be Accepted Width 192 cm, Auspicious/Good 
              Luck in Exam and Be Accepted/Prosperity/Gaining Treasure
              </p>
              {/* -- */}

              <hr /> 

              {/* Number Points */} 

              <ul id="list">
                <li id="bullet">
                6. The original drawing of “Beijing Fahai Zen Monastery Mural Paintings” is  registered with the National Copyright Administration of The Peoples Republic of China and is honored the certificate of copyright registration for “ Beijing Fahai Zen Monastery Mural Paintings”The registration number is : 國作登字-2013-F-00092999. Its copyright is worldwide protected.
                </li>
                <li id="bullet">
                7. In order to feature the accent of both colorful elegance and sophistication in Chinese meticulous painting, and the majesty, grandeur, magnificence, meticulousness of Song Dynasty Court mural paintings, the patented techniques and the unique craftsman's skills are used in production to break through the limitations of giclee printing,  specifically in the resolution accuracy of image information acquisition, image processing technique of high pixel density, color restoration technique, integration of primary colors, traits of colors and texture, ultrafine particles processing.
                </li>
                <li id="bullet">
                8. In order to keep with the cultural essences of Ming Dynasty, the ancient simplicity,  and eco-friendly conscious living are buried in mind during the stages of mounting   and scroll storage box making. Adorned with elaborated metal parts, scroll storage boxes are made from highly qualified Chinese parasol tree wood and camphorwood  in the traditional way following ancient people’s taste and habits. It approaches        lightweight and simplicity without loss of its classical genre. It is consistent with the theme of applying modern materials in traditional methods. Ideally preserving the integrity of intriguing scenarios and displaying without flamboyance is the  Indispensable quintessence in decoration and packaging of “ Beijing Fahai Zen  Monastery Mural Paintings”.
                </li> 
              </ul> 

              {/* -- */} 

              <p id="art-paragraph-other">
              There are two print versions, display version and family version. Totally there are 3,333 sets. Each printing has 
              its unique anti-fraud universal barcode distinguishing its limited edition and its worldwide copyright registration 
              numbers. There are few reasons that we only produce this number of 3,333 sets. First of all, the auspicious 3 
              represents infinite number. Also, limited printing will keep and increase the market value of “Beijing Fahai Zen 
              Monastery Mural Paintings”. Secondary, there are more than 33,000 three gem monasteries in Mainland China. A monastery 
              has 3 gems means that there are Buddha, Dharma and Sangha in this monastery. Besides monasteries, the majority 
              collectors are art academies, art exhibition organizers, Buddhist lay people, private collectors and collectors in 
              the gift market. 
              </p> 

              <p id="art-paragraph-other">
              Accumulated with countless approaches of wisdom, “Beijing Fahai Zen Monastery Mural Paintings” reached culminating 
              excellence in art, reproduction of fine art, new technology, packaging and more. It undoubtedly is worthy of its name 
              as the benchmark of Buddhist mural art. It can fulfill the appetites of both the viewers and the art collectors. 
              It rescues, protects, inherits, and promotes Chinese Buddhist culture. It’s a new attempt based on the traditional 
              Buddhist mural art approach in artwork, professional fine art reproduction and in printing.“Beijing Fahai Zen Monastery 
              Mural Paintings” presents a rarely sacred opportunity to reveal the spectacular uniqueness of Fahai Zen Monastery 
              Frescoes. 
              </p> 

              <p id="art-paragraph-other">
              The birth of “Beijing Fahai Zen Monastery Mural Paintings” is an epoch-making event for Chinese Buddhist art. 
              Through applying the complexed engraving production technology, the reincarnation of the marvelous Buddhist 
              frescoes indicates the glorious future of contemporary Chinese Buddhist culture development. It accentuates 
              the spirit of China. It opens an artistic window for Chinese Buddhism to spread the Buddha's teaching all 
              over the world. 
              </p> 

              <p id="art-paragraph-other">
              The publisher of Fahai Zen Monastery Frescoes will organize conferences, periodic seminars for scholars of Fahai 
              Zen Monastery Frescoes. He will also publish the research papers on website. There will have world tour exhibitions 
              for Beijing Fahai Zen Monastery Mural Paintings. Displaying Chinese cultural classic to the world, the exhibition 
              will also conjoin the concept of “Worldly Peace Starting From Heart” with the glamours of Chinese Buddhist mural art.
              </p> 

              <p id="art-paragraph-other">
              Accumulated with countless approaches of wisdom, “Beijing Fahai Zen Monastery Mural Paintings” reached culminating 
              excellence in art, reproduction of fine art, new technology, packaging and more. It undoubtedly is worthy of its name 
              as the benchmark of Buddhist mural art. It can fulfill the appetites of both the viewers and the art collectors. It 
              rescues, protects, inherits, and promotes Chinese Buddhist culture. It’s a new attempt based on the traditional Buddhist 
              mural art approach in artwork, professional fine art reproduction and in printing.“Beijing Fahai Zen Monastery Mural 
              Paintings” presents a rarely sacred opportunity to reveal the spectacular uniqueness of Fahai Zen Monastery Frescoes. 
              The birth of “Beijing Fahai Zen Monastery Mural Paintings” is an epoch-making event for Chinese Buddhist art. Through 
              applying the complexed engraving production technology, the reincarnation of the marvelous Buddhist frescoes indicates 
              the glorious future of contemporary Chinese Buddhist culture development. It accentuates the spirit of China. It opens 
              an artistic window for Chinese Buddhism to spread Frescoes. 
              </p> 

              <h6 className="translator">Translator: Pingping Huang</h6> 

              <img src="./ZF6.jpeg" id="painting-zf"></img>
              {/* <img src="./ZF.jpeg" id="painting-zf"></img> */}
              <h5 id="caption">Display Version</h5> 

              <img src="./ZF7.jpeg" id="painting-zf"></img> 
              {/* <img src="./ZF.jpeg" id="painting-zf"></img> */} 
              <h5 id="caption">Family Version</h5> 

          </div>
          </> 
    );
  }
  
  export default ZenFrescosMandarin; 